export default __webpack_public_path__ + "static/media/logo-circulo-white.28551914.png";